'use client';

import { VariantProps } from 'class-variance-authority';
import { ArrowLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { MouseEventHandler, useCallback } from 'react';
import { useReadLocalStorage } from 'usehooks-ts';
import { Button, buttonVariants } from '@/components/ui/button';
import { LOCAL_STORAGE_SEARCH_KEY } from '@/lib/config';
import { cn } from '@/lib/utils';
const buttonClasses = 'text-base font-900 font-heading text-primary uppercase';
export const BackButton = ({
  icon = <ArrowLeft />,
  variant = 'ghost',
  text = 'Back',
  to
}: VariantProps<typeof buttonVariants> & {
  to?: string;
  text?: string;
  icon?: JSX.Element;
}) => {
  const router = useRouter();
  const searchStore = useReadLocalStorage<string | undefined>(LOCAL_STORAGE_SEARCH_KEY);
  const onBack: MouseEventHandler<HTMLButtonElement> = useCallback(() => {
    if (to && to.startsWith('/search') && searchStore) {
      const urlParams = new URLSearchParams(searchStore);
      router.push(`${to}/?${urlParams}`, {
        scroll: false
      });
    } else if (to) {
      router.push(to, {
        scroll: false
      });
    } else {
      router.back();
    }
  }, [router, searchStore, to]);
  return <Button className={cn({
    [buttonClasses]: variant === 'ghost'
  })} variant={variant} onClick={onBack}>
      {icon} {text}
    </Button>;
};